import * as React from 'react';
import clx from 'classnames';
import { Col, Space, Divider } from 'antd';
import './ProcedureViewSummaryColumn.scss';
import { IProcedure } from 'common/schema/Procedure';
import { ProcedureSummary } from '../summary/ProcedureSummary';
import { PageSecondaryColumn } from 'client/ui/layout/page/PageSecondaryColumn';

export interface ProcedureViewSummaryColumnProps {
  procedure: IProcedure;
  children: React.ReactNode;
}

/**
 * Sezione della pagina di una domanda (colonna destra)
 * che include il sommario della domanda per il cittadino
 * ed è il contenitore dei pulsanti per la compilazione
 *
 * Questo elemento è condiviso anche con la pagina di Anteprima lato Admin
 */
export function ProcedureViewSummaryColumn(
  props: ProcedureViewSummaryColumnProps
) {
  const { procedure } = props;

  return (
    <PageSecondaryColumn className="procedure-view-summary-column">
      <ProcedureSummary procedure={procedure} />
      <Space direction="vertical" size={12} className="procedure-button">
        <Divider className="responsive-hide" />
        {props.children}
      </Space>
    </PageSecondaryColumn>
  );
}
